window.updateBackorderMessage = function updateBackorderMessage() {
  // Retrieve the selected variant ID from the span content
  const selectedVariantId = document.querySelector('.variant-id-preorder').textContent.trim();
  console.log("Current Selected Variant ID:", selectedVariantId);

  // Ensure that product variants are loaded in the global scope
  if (!window.productData || !window.productData.variants) {
    console.warn("Product data not found. Ensure 'window.productData.variants' contains data.");
    return;
  }

  // Find the matching variant in the product data
  const variant = window.productData.variants.find(v => v.id == selectedVariantId);
  if (!variant) {
    console.warn("Variant not found for ID:", selectedVariantId);
    return;
  }

  console.log("Variant found:", variant);

  const preorderContainer = document.querySelector('.preorder-container');
  if (!preorderContainer) {
    console.warn("Preorder container element not found.");
    return;
  }

  // Show or hide preorder container based on conditions
  if (variant.continueSellingOutOfStock === "continue" && variant.inventory_quantity <= 0) {
    preorderContainer.style.display = 'block';
    console.log("Preorder container displayed.");
  } else {
    preorderContainer.style.display = 'none';
    console.log("Preorder container hidden.");
  }
};

// Initial check on page load
window.updateBackorderMessage();